/** Adresse à taper sur l'ordinateur de la TV : celle de cette console (prod : console.unboared.com). */
export function consoleAddress() {
    return window.location.host;
}
